import React from "react";
import NumberQuestionTypeValidation from "features/ManageOfferings/modules/BookingQuestions/modules/QuestionTypeValidations/NumberQuestionTypeValidation/NumberQuestionTypeValidation";
import {
  CalendarQuestionTypeShowAnswer,
  DefaultQuestionTypeShowAnswer,
  FileQuestionTypeShowAnswer,
  FileQuestionTypeValidation,
  MultiSelectQuestionTypeShowAnswer,
  SelectOptionTypeValidation,
  SingleSelectQuestionTypeShowAnswer,
  TextQuestionTypeValidation,
} from "../schedule-v2/commonPages/Components/QuestionCards/QuestionTypeComponents";
import { is_empty } from "features/Common/utils/common.utils";
import { EmptyMediaResponse } from "features/Crm/modules/CustomerDetails/modules/Timeline/modules/TimelineLogs/modules/Common/Media/EmptyMediaResponse";
import { FEATURE_KEYS } from "features/MySubscriptions/constants/MySubscriptions.constants";
import { MULTI_CHECKBOX_INPUT_TABLE_TYPES } from "features/Account/modules/Communications/modules/ContactForm/modules/QuestionForm/modules/common/MultiCheckBoxInputTable/constants/MultiCheckBoxInputTable.constants";

export const customer_questions_constants = {
  customer_schedule_status: {
    action_required: 1,
    scheduled: 2,
    completed: 3,
  },

  avaibility_type: {
    occur_on_selected_days_of_week: 6,
    occur_on_selected_dates: 5,
    not_decided: 4,
    custom: 3,
    weekday: 2,
    single_day: 1,
    everyday: 0,
  },
};

export const question_type_id = {
  PARAGRAPH_TEXT: 1,
  SINGLE_SELECT_DROPDOWN: 2,
  MULTI_SELECT_DROPDOWN: 3,
  CALENDAR: 4,
  FILE: 5,
  SHORT_TEXT: 9,
  NUMBER: 10,
  URL: 11,
  GENDER: 12,
  INDIAN_STATE: 13,
  INDIAN_CITY: 14,
  PAN: 17,
  GST: 18,
};

export const questions_type_mapping = {
  [question_type_id.PARAGRAPH_TEXT]: {
    id: 1,
    value: 1,
    label: "Text",
    typeSpecificValidation: () => <TextQuestionTypeValidation />,
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.SINGLE_SELECT_DROPDOWN]: {
    id: 2,
    value: 2,
    label: "Single selection option",
    typeSpecificValidation: (question) => (
      <SelectOptionTypeValidation question={question} />
    ),
    hasChoices: true,
    tooltip:
      "These options will show up as a dropdown by default. You can also display them as radio buttons.",
    showAnswer: (answer) => (
      <SingleSelectQuestionTypeShowAnswer answer={answer} />
    ),
  },
  [question_type_id.MULTI_SELECT_DROPDOWN]: {
    id: 3,
    value: 3,
    label: "Multiple selection option",
    typeSpecificValidation: (question) => (
      <SelectOptionTypeValidation question={question} />
    ),
    hasChoices: true,
    tooltip:
      "These options will show up as a dropdown by default. You can also display them as checkboxes.",
    showAnswer: (answer) => (
      <MultiSelectQuestionTypeShowAnswer answer={answer} />
    ),
  },
  [question_type_id.CALENDAR]: {
    id: 4,
    value: 4,
    label: "Date",
    showAnswer: (answer) => <CalendarQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.FILE]: {
    id: 5,
    value: 5,
    label: "File",
    typeSpecificValidation: () => <FileQuestionTypeValidation />,
    showAnswer: (answer) => {
      if (!is_empty(answer?.text_answer))
        return <FileQuestionTypeShowAnswer answer={answer} />;
      return <EmptyMediaResponse />;
    },
  },
  [question_type_id.SHORT_TEXT]: {
    id: 6,
    value: 9,
    label: "Short Text Question",
    typeSpecificValidation: (question) => (
      <TextQuestionTypeValidation question={question} />
    ),
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.NUMBER]: {
    id: 7,
    value: 10,
    label: "Number",
    typeSpecificValidation: () => <NumberQuestionTypeValidation />,
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.URL]: {
    id: 8,
    value: 11,
    label: "URL",
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.GENDER]: {
    id: 9,
    value: 12,
    label: "Gender",
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.INDIAN_STATE]: {
    id: 10,
    value: 13,
    label: "Indian State",
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.INDIAN_CITY]: {
    id: 11,
    value: 14,
    label: "Indian City",
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.PAN]: {
    id: 12,
    value: question_type_id.PAN,
    label: "PAN",
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
  [question_type_id.GST]: {
    id: 13,
    value: question_type_id.GST,
    label: "GST",
    showAnswer: (answer) => <DefaultQuestionTypeShowAnswer answer={answer} />,
  },
};

export const questions_placement_mapping = {
  before_booking: 1,
  after_booking: 2,
};

export const KYC_QUESTIONS_COLUMNS_KEYS = {
  IS_VISIBLE: "is_visible",
  IS_MANDATORY: "is_mandatory",
  QUESTION: "question",
};

export const KYC_QUESTIONS_COLUMNS_CONFIG = [
  {
    key: KYC_QUESTIONS_COLUMNS_KEYS.QUESTION,
    title: "Field",
    type: MULTI_CHECKBOX_INPUT_TABLE_TYPES.TEXT,
    align: "left",
  },
  {
    key: KYC_QUESTIONS_COLUMNS_KEYS.IS_VISIBLE,
    title: "Is visible",
    type: MULTI_CHECKBOX_INPUT_TABLE_TYPES.CHECKBOX,
    align: "left",
  },
  {
    key: KYC_QUESTIONS_COLUMNS_KEYS.IS_MANDATORY,
    title: "Is mandatory",
    type: MULTI_CHECKBOX_INPUT_TABLE_TYPES.CHECKBOX,
    align: "left",
  },
];

export const QUESTION_TYPE_ID_FEATURE_KEY_MAPPING = {
  [question_type_id.PAN]: FEATURE_KEYS.pan_kyc.key,
  [question_type_id.GST]: FEATURE_KEYS.gst_kyc.key,
};
